/**
 * API методы для работы с tenants (для SuperAdmin)
 * Дата: 28.12.2025 - Создан для TODO-013 (TenantSelector компонент)
 * Связан с: internal/handler/tenant.go, frontend/src/components/ui/TenantSelector.tsx
 */
import { apiClient } from './client';

export interface Tenant {
  id: string;
  slug: string;
  name: string;
  is_active: boolean;
  created_at: string;
}

export interface ChannelDirectoryData {
  telegram_client_url?: string;
  telegram_client_configured: boolean;
  telegram_bot_username?: string;
  telegram_bot_url?: string;
  telegram_bot_configured: boolean;
  max_bot_username?: string;
  max_bot_url?: string;
  max_configured: boolean;
  sms_sender_id?: string;
  sms_enabled: boolean;
  sms_provider?: string;
  sms_account_name: string;
  sms_note: string;
  beeline_configured?: boolean;
  beeline_sender_id?: string;
  beeline_note?: string;
  sms_tel_configured?: boolean;
  sms_tel_line?: string;
}

export interface UpdateChannelDirectoryRequest {
  telegram_client_url?: string;
  telegram_bot_username?: string;
  max_bot_username?: string;
  sms_sender_id?: string;
}

export const tenantsApi = {
  list: async (): Promise<{ tenants: Tenant[]; total: number }> => {
    const response = await apiClient.get('/admin/tenants');
    return response.data;
  },

  getChannelDirectory: async (tenantId?: string): Promise<ChannelDirectoryData> => {
    const params: Record<string, string> = {};
    if (tenantId) params.tenant_id = tenantId;
    const response = await apiClient.get<ChannelDirectoryData>('/settings/channels-directory', { params });
    return response.data;
  },

  updateChannelDirectory: async (data: UpdateChannelDirectoryRequest, tenantId?: string): Promise<ChannelDirectoryData> => {
    const params: Record<string, string> = {};
    if (tenantId) params.tenant_id = tenantId;
    const response = await apiClient.put<ChannelDirectoryData>('/settings/channels-directory', data, { params });
    return response.data;
  },
};

